var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFaceFrown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "face-frown 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "face-frown",
    d: "M12 22.75C6.072 22.75 1.25 17.928 1.25 12C1.25 6.072 6.072 1.25 12 1.25C17.928 1.25 22.75 6.072 22.75 12C22.75 17.928 17.928 22.75 12 22.75ZM12 2.75C6.899 2.75 2.75 6.899 2.75 12C2.75 17.101 6.899 21.25 12 21.25C17.101 21.25 21.25 17.101 21.25 12C21.25 6.899 17.101 2.75 12 2.75ZM16.25 10C16.25 8.986 15.725 8.25 15 8.25C14.275 8.25 13.75 8.986 13.75 10C13.75 11.014 14.275 11.75 15 11.75C15.725 11.75 16.25 11.014 16.25 10ZM10.25 10C10.25 8.986 9.725 8.25 9 8.25C8.275 8.25 7.75 8.986 7.75 10C7.75 11.014 8.275 11.75 9 11.75C9.725 11.75 10.25 11.014 10.25 10ZM16.451 17.599C16.782 17.35 16.848 16.88 16.599 16.549C15.516 15.109 13.8 14.25 12.009 14.25C10.197 14.25 8.522 15.087 7.412 16.546C7.161 16.876 7.225 17.346 7.555 17.597C7.885 17.847 8.356 17.783 8.606 17.454C9.429 16.371 10.67 15.75 12.009 15.75C13.331 15.75 14.599 16.386 15.4 17.451C15.547 17.647 15.772 17.75 16.001 17.75C16.157 17.75 16.315 17.701 16.451 17.599Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFaceFrown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/face-frown.6d8e01fb.svg";
export { ForwardRef as ReactComponent };